import styled from "styled-components";
import { Button as RCLButton } from "@ebscois/react-component-library";

export const Button = styled(RCLButton)`
  opacity: 0;

  ${({ $isVisible }) =>
    $isVisible &&
    `opacity: 1;
    transition: opacity 1s;
  `};

  svg {
    background: ${({ theme }) => theme.colors.senary.base};
    border-color: ${({ theme }) => theme.colors.senary.base};
  }
`;
